import { getCall, setCall } from './sessionHandler'
import { publishEvent } from '../events/publishers/callEventPublisher'
import peerConnection from './peerConnection'
import callEvents from './callEvents'
import { emitCallEvent } from '../../services/screen-pop'
import { get } from '../../utils/session-handler'
import { isNullOrEmpty, hasAsterisk } from '../../utils/utils'

const setCallAndRedirect = async (e) => {
  setCall(e)

  publishEvent('incomingCall', e.request.from.uri.user)

  const username = get('username')

  const displayName = e.request.from.display_name;
  const value = (hasAsterisk(displayName) && !isNullOrEmpty(displayName)) ? displayName.split('*')[1] : null;

  if(!isNullOrEmpty(value)) await emitCallEvent(username, value);

  listenerEvents(e);
}

const listenerEvents = e => {
  e.session.on('peerconnection', peerConnection)

  e.session.on('ended', ev => {
    callEvents.ended(ev)
    setCall(undefined)
  })

  e.session.on('failed', ev => {
    callEvents.ended(ev)
    setCall(undefined)
  })
}

const acceptCall = () => {
  const call = getCall()

  call?.session.answer()

  setCall(call)
}

const declineCall = () => {
  const call = getCall()

  call?.session.terminate()

  setCall(undefined)
}

export { setCallAndRedirect, acceptCall, declineCall }
